/** HEAT for one building: passive cooling, Lay Low, staffed-lookout reduction. */
import type { City, Building } from './types';
import { SIM, roomDef } from './config';
import { workersOf } from './jobs';
import { defenseMul, isAvailable } from './colonist';

/** Bonus for bracing a room during a raid telegraph — the crew turtles up. */
export const BRACE_DEFENSE_MUL = 1.15;

/** Raid defense for a building: staffed lookouts + crew combat + upgrades. */
export function totalDefense(b: Building, now: number): number {
  let def = 0;
  for (const room of b.rooms) {
    if (room.type !== 'security' || room.damagedUntil > now) continue;
    if (workersOf(b, room).length > 0) def += (roomDef('security').defense ?? 0) * room.tier;
  }
  for (const c of b.colonists) {
    if (!isAvailable(c, now)) continue;
    def += c.skills.combat.level * 0.8 * defenseMul(c);
  }
  def += (b.security.cameras ?? 0) * 5;
  if (b.raid?.bracedRoomId != null) def *= BRACE_DEFENSE_MUL;
  return def;
}

export function safeThreshold(b: Building): number {
  return SIM.SAFE_THRESHOLD + (b.security.bribes ?? 0) * 5;
}

export function applyHeat(city: City, b: Building, dt: number): void {
  const now = city.t;
  let cool = SIM.HEAT_DECAY;
  if (b.layingLow) cool += SIM.HEAT_LAYLOW;
  for (const room of b.rooms) {
    if (room.type !== 'security' || room.damagedUntil > now) continue;
    if (workersOf(b, room).length > 0) cool += (roomDef('security').heatReduce ?? 0) * room.tier;
  }
  for (const e of city.activeEvents) if (e.heatPerSec) b.heat += e.heatPerSec * dt;
  b.heat = Math.max(0, Math.min(100, b.heat - cool * dt));
}
